import api from '../../Api/feathers-client';
import { addDays } from '../../Js/TimeAndDate';

// Function [validatePasscode] : To call CRM api and check that passcode is valid or not and if passcode is valid then return passcode related customer and product details

export const validatePasscode = (passcode) => {
    return new Promise(async  (resolve, reject) => {
        let proData = await api.service('license-validate-from-crm').get(passcode);
        resolve(proData);
    }) 
}

// Function [prepareProductData] : To update validity of license whenever it installed on local server and check related product and product data is on destination (server side 'productUpload' folder) folder or not

export const prepareProductData = async (productData, whoAmIData, installationType) => {
    
    productData.data.productInfo.licenseExpiry[0].renewal_from = new Date();
    productData.data.productInfo.licenseExpiry[0].valid_till = addDays(productData.data.productInfo.licenseExpiry[0].renewal_from, productData.data.productInfo.licenseExpiry[0].period);
    productData.data.productInfo.licenseExpiry[0].is_active = true;
    productData.data.productInfo.licenseExpiry[0].updated_on = new Date();
    productData.data.productInfo.expiryDate = productData.data.productInfo.licenseExpiry[0].valid_till;

    if(whoAmIData.customer_uuid === null){
        let products = [];
        products.push(productData.data.productInfo);

        let endPointData = await api.service('files-read').find({
            query:{
                envName: 'END_POINT'
            }
        });
        let productVerifed = null;


        if(endPointData !== 'live' && installationType !== 'web'){
            
            return new Promise(async (resolve, reject) => {
                productVerifed = await api.service('add-product-data').patch('',{},{
                    query:{
                      productId: productData.data.productInfo['productId'],
                      productVersion: productData.data.productInfo['productVersion'],
                      type: 'install'
                    }
                  });

                  console.log("AAAAAA",productVerifed);
    
                if(productVerifed !== 'done'){
                  if(productVerifed === 'productidfailed'){
                    resolve('Product does not match with passcode.');
                  }
                  else if(productVerifed === 'productversionfailed'){
                    resolve('Product version does not match with passcode.');
                  }
                  else if(productVerifed === 'productnotavailable'){
                    resolve('Full product is unavailable.');
                  }
                  else{
                    resolve(false);
                  }
                }
                else{
                    resolve(true);
                }
            })
        }

    }
};

// Function [initialDataSeed] : Call a service 'initial-data-seed' which insert all initial data required to setup a school in offline (like default enumeration, hode & admin user etc...)

export const initialDataSeed = (params) => {

    return new Promise (async (resolve,reject) => {
            try{
                let res = await api.service('initial-data-seed').create({},{
                    query: params.paramObj
                });

                if(res.status === 200){
                    await api.service('license-validate-from-crm').patch(params.paramObj.customerInfo.customer_uuid,{
                        passcode:params.passcode,
                        systemuid: params.paramObj.whoami.server_info.systemuid,
                        licenseExpiry: params.paramObj.productInfo.licenseExpiry
                    },{});
      
                    // copy customer branding images from crm
                    await api.service('get-branding-media').find({
                      query:{
                        site_uuid: params.paramObj.customerInfo.customer_uuid
                      }
                    });
                }

                resolve(res);
            }
            catch(err){
                reject(err);
            }
        }
    );
    
}

export const productInstall = (params) => {
  return new Promise(async  (resolve, reject) => {

      await api.service('add-product-data').find();

      //update whoami file and server registration into CRM
      await api.service('files-read').patch('.whoami', {
        'customer_uuid': params.customerInfo.customer_uuid
      }, {});

      let data = {
        customer_uuid: params.customerInfo.customer_uuid
      };
      let update_server = await api.service('check-customer-from-web-server').patch(params.whoAmIData.uid, data);

      await api.service('license-validate-from-crm').patch(params.customerInfo.customer_uuid,{
          passcode:params.passcode,
          systemuid: params.whoAmIData.server_info.systemuid,
          licenseExpiry: params.productInfo.licenseExpiry
      },{});

      // copy customer branding images from crm
      await api.service('get-branding-media').find({
        query:{
          site_uuid: params.customerInfo.customer_uuid
        }
      });

  }) 
}

export const serverRegistration = (customerUid) => {
  return new Promise(async  (resolve, reject) => {
    console.log("customerUid",customerUid);
      let serverData = await api.service('check-customer-from-web-server').get(customerUid);
      resolve(serverData);
  }) 
}